module.exports = __webpack_public_path__ + "img/interstitial_5.fdbb4e2a.jpg";